export default __webpack_public_path__ + "static/media/Short Details Card 1.defb9549.png";